@if (visible) {
<div class="tw"
     [class.collapsed]="collapsed"
     [class.urgent]="urgent"
     [class.expired]="expired"
     [class.dragging]="dragging"
     [style.left.px]="x"
     [style.top.px]="y">

  <!-- Collapsed: animated pill -->
  @if (collapsed) {
    <div class="tw-pill" (mousedown)="onMouseDown($event)" (touchstart)="onTouchStart($event)" (click)="toggle()">
      <div class="tw-pill-dot" [class.blink]="urgent"></div>
      @if (!expired) {
        <span class="tw-pill-days">{{ days }}<small>j</small> {{ hours }}<small>h</small> {{ minutes }}<small>m</small> {{ seconds }}<small>s</small></span>
      } @else {
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ 'TRIAL_WIDGET.EXPIRED' | translate }}</span>
      }
    </div>
  }

  <!-- Expanded: full widget -->
  @if (!collapsed) {
    <div class="tw-card" (mousedown)="onMouseDown($event)" (touchstart)="onTouchStart($event)">
      <div class="tw-header">
        <div class="tw-header-left">
          <div class="tw-header-dot" [class.blink]="true"></div>
          <span>{{ 'TRIAL_WIDGET.TITLE' | translate }}</span>
        </div>
        <button class="tw-close" (click)="toggle(); $event.stopPropagation()">
          <i class="pi pi-minus"></i>
        </button>
      </div>

      <div class="tw-body">
        <div class="tw-company">{{ companyName }}</div>
        @if (planName) {
          <div class="tw-plan">{{ planName }}</div>
        }

        @if (!expired) {
          <div class="tw-countdown">
            <div class="tw-unit">
              <span class="tw-num">{{ days | number:'2.0-0' }}</span>
              <span class="tw-lbl">{{ 'TRIAL_WIDGET.DAYS' | translate }}</span>
            </div>
            <span class="tw-sep" [class.blink]="true">:</span>
            <div class="tw-unit">
              <span class="tw-num">{{ hours | number:'2.0-0' }}</span>
              <span class="tw-lbl">{{ 'TRIAL_WIDGET.HOURS' | translate }}</span>
            </div>
            <span class="tw-sep" [class.blink]="true">:</span>
            <div class="tw-unit">
              <span class="tw-num">{{ minutes | number:'2.0-0' }}</span>
              <span class="tw-lbl">{{ 'TRIAL_WIDGET.MIN' | translate }}</span>
            </div>
            <span class="tw-sep" [class.blink]="true">:</span>
            <div class="tw-unit tw-unit-sec">
              <span class="tw-num tw-num-sec">{{ seconds | number:'2.0-0' }}</span>
              <span class="tw-lbl">{{ 'TRIAL_WIDGET.SEC' | translate }}</span>
            </div>
          </div>

          <!-- Progress bar -->
          <div class="tw-progress-track">
            <div class="tw-progress-bar"
                 [style.width.%]="progress"
                 [style.background]="progressColor">
            </div>
          </div>
          <div class="tw-progress-label">{{ 'TRIAL_WIDGET.PERCENT_REMAINING' | translate: { percent: (progress | number:'1.0-0') } }}</div>
        } @else {
          <div class="tw-expired-block">
            <div class="tw-expired-icon">
              <i class="pi pi-exclamation-triangle"></i>
            </div>
            <div class="tw-expired-msg">{{ 'TRIAL_WIDGET.EXPIRED' | translate }}</div>
          </div>
        }

        <button class="tw-upgrade" (click)="goToBilling(); $event.stopPropagation()">
          <i class="pi pi-arrow-up-right"></i> {{ 'TRIAL_WIDGET.UPGRADE' | translate }}
        </button>
      </div>
    </div>
  }
</div>
}
